<template>
  <a class="favorites" :class="{'in': length}" :href="href" :disabled="!length" @mouseover="buildUrl">
      <i>
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="20" height="18" viewBox="0 0 21 20" src="/t/dk/i/icons/star.svg?178528e0ec" class="svg">
          <g fill="none" stroke="#ff6659" transform="translate(0,1)">
            <path d="M9.998,0.000 L13.088,5.925 L19.999,6.876 L14.999,11.487 L16.179,18.000 L9.998,14.925 L3.817,18.000 L4.998,11.487 L-0.003,6.876 L6.909,5.925 L9.998,0.000 Z"></path>
          </g>
        </svg>
      </i>
      избранное
  </a>
</template>
<script>
import { mapGetters, mapActions} from 'vuex'
import Favorite from './components/Favorite'

import LZString from 'lz-string'
import replaceBulk from './replaceBulk.js'

export default {
  name: 'dkfavorites',
  components: {
    Favorite
  },

  data(){
    return{
      compressed: ''
    }
  },

  computed: {
    ...mapGetters({
      favorites: 'favoritesEstates',
      length: 'getNumberOfFavoritesEstates'
    }),
    href() {
      let href = this.length ? '/catalog/favorites' : '#favorites';
      href = this.length ? href + '?' + this.compressed : href;
      return href;
    }
  },

  methods:{
    buildUrl(){
      let favs = JSON.parse(localStorage.getItem('favorites'))
      if (favs) {
        favs = JSON.stringify(favs.added);
        // replaceBulk(str, ['g','t','i'], ['estate_group','estate_type','id']);
        favs = replaceBulk(favs, ['estate_group','estate_type','id'], ['g','t','i']);
        // console.log('localStorage favs', favs);
        this.compressed = encodeURIComponent(LZString.compressToEncodedURIComponent(favs))
        if (document.querySelector('.b-favorites-title')) {
          // b-favorites-title
          let state = { 'compressed': this.compressed };
          let title = 'Избранное';
          let url = this.href;
          history.pushState(state, title, url);
        }
        console.log('localStorage compressed', this.compressed);
      }
    }
  },

  // https://www.mikestreety.co.uk/blog/vue-js-using-localstorage-with-the-vuex-store
  mounted(){
    // Subscribe to store updates
    this.$store.subscribe((mutation, state) => {
      // Store the state object as a JSON string
      localStorage.setItem('favorites', JSON.stringify(state));
      this.buildUrl();
    });
    this.buildUrl();
  },
  beforeCreate() {
		this.$store.commit('initialiseStore');
	}

}
</script>

<style lang="scss">
a.favorites{
  &.in{
    i{
      .svg g {
        fill: #ff6659;
        stroke: #ff6659;
      }
    }
  }
  &[disabled]{
    cursor: default;
  }
}
</style>



// WEBPACK FOOTER //
// src/Dkfavorites.vue